module.exports = __webpack_public_path__ + "img/access2.063ac18e.png";